module.exports = __webpack_public_path__ + "static/media/M1-11-Temerius-Ragnor-cod110.8ed50a92.png";